export const team_home = [
    {
        id: "leader-1",
        img:"https://drive.google.com/uc?export=view&id=19wfPpRgN5Vocm7iRKDqemhbZ20YhBY_g",
        title: "Rohit Kulkarni, president Cyber Club",
        content: "Rohit is a high school student at Freedom High School with an aptitude for STEM. As an aspiring computer scientist interested in the intersection of machine learning and biology, he is always ready to learn and challenge himself in a growingly technology-dependent world. Along with school, he likes educating himself about the newest advancements in technology, playing tennis, and riffing on the guitar.",
    },
]

export const team_ml = [
    {
        id: "leader-1",
        img:"https://drive.google.com/uc?export=view&id=19wfPpRgN5Vocm7iRKDqemhbZ20YhBY_g",
        title: "Rohit Kulkarni, ML President",
        content: "Rohit is a high school student at Freedom High School with an aptitude for STEM. As an aspiring computer scientist interested in the intersection of machine learning and biology, he is always ready to learn and challenge himself in a growingly technology-dependent world. Along with school, he likes educating himself about the newest advancements in technology, playing tennis, and riffing on the guitar.",
    },
    {
        id: "leader-2",
        img:"",
        title: "Shourya Agarwal, ML officer - Content",
        content: "Shourya is a student at Freedom and AET. He has worked on various computer vision projects through robotics and the Edge Impulse platform. He is alsoexperienced with arduino and electronics.",
    },
    {
        id: "leader-3",
        img:"https://drive.google.com/uc?export=view&id=15GKby4nIaW9o-ZA_vCrHNFVmnyHNHJ6B",
        title: "Shlesh Sakpal, ML officer - Outreach",
        content: "Shlesh is a sophomore at Freedom. He has worked on various research at the intersection of artificial intelligence and black holes. He hopes to bring a successful learning experience to all students in ML Club",
    },
    
]

export const team_aws = [
    {
        id:"leader-1",
        img:"",
        title: "Saamarth Attray, President of AWS club",
        content: "",
    },
    {
        id:"leader-2",
        img:"",
        title: "Suhas Adavelly, Secretary of AWS Club",
        content: "",
    },
]

export const team_cybersec = [
    {
        id:"leader-1",
        img:"",
        title: "Anjana Kumar, Cybersecurity President",
        content: "",
    },
    {
        id:"leader-2",
        img:"",
        title: "Shehab Salem, Cybersecurity Vice President",
        content: "",
    },
    {
        id:"leader-3",
        img:"",
        title: "Riya Pasupulati, Cybersecurity Secretary",
        content: "",
    }
]






export const projects_home = [
    {
        id: "project-1",
        img: "https://www.spokaneschools.org/cms/lib/WA50000187/Centricity/Domain/2303/CyberPatriot_860-700x469.jpg",
        title: "Air Force Association (AFA) Cyberpatriot Competition",
        content: "Contact a club officer to join the Cyberpatriot competition",
    }
]

export const projects_ml = [
    {
        id: "project-1",
        img: "https://prachisablani.github.io/images/House2.jpg",
        title: "Housing Prices Prediction",
        content: "Club members working on analyzing housing data and using regression models to predict housing prices in the future.",
    }
]

export const projects_cybersec = [
    {
        id: "project-1",
        img: "https://img.freepik.com/premium-vector/operation-project-icon-comic-style-gear-process-vector-cartoon-illustration-white-isolated-background-technology-produce-business-concept-splash-effect_157943-5822.jpg?w=2000",
        title: "Mini-Capture the Flag (CTF)",
        content: "Capture the flag event designed for all students.",
    }
]

export const projects_aws = [
    {
        id: "project-1",
        img: "https://d1.awsstatic.com/training-and-certification/certification-badges/AWS-Certified-Cloud-Practitioner_badge.634f8a21af2e0e956ed8905a72366146ba22b74c.png",
        title: "AWS Certification",
        content: "Working towards and AWS certification towards the end of the year.",
    }
]






export const about_home = {
    id: "about-home",
    title: "About Cyber Club!",
    content: "Cyber Club is a club encompassing three separate pathways/clubs: Machine learning (ML), Amazon Web Services (AWS), and Cybersecurity. The goal of the Cyber Club is to enable all students to become more technologically literate, whether it is coding or cybersecurity defense. The Cyber Club is also home to the Freedom Cyberpatriot teams, who compete nationally in the Air Force Association (AFA) Cyberpatriot competition.",
}

export const about_ml = {
    id: "about-ml",
    title: "About Machine Learning (ML) Club!",
    content: <p>Machine learning (ML) club has a focus on educating Freedom students about the applications of Artificial Intelligence, Machine Learning, and Deep Learning. We aim to bring the vast concepts of ML to high school students, from Support Vector Machines (SVMs) to Neural Networks. <ul> <li><a href="https://linktr.ee/freedomml" target="_blank">Access the linktree Here!</a></li> <li>Access the <a href="https://drive.google.com/drive/folders/1RTUzkMTqHChpfxQ0peb4IDwYJM0fP1AE?usp=sharing" target="_blank">Slideshows and Presentations For the Club</a></li> <li>Access the <a href="https://www.kaggle.com/fhsmlclub" target="_blank">Kaggle code notebooks</a></li> <li>The remind join link is <a href=" https://www.remind.com/join/fhsaiml" target="_blank">here</a></li></ul></p>,
}

export const about_cybersec = {
    id: "about-cybersec",
    title: "About Cybersecurity Club!",
    content: "Cybersecurity club is aimed at introducing the fundamental concepts of system defense to the Freedom community",
}

export const about_aws = {
    id: "about-aws",
    title: "About AWS Club!",
    content: "Amazon Web Services club has a focus on teaching the Freedom community to explore avenues in cloud computing.",
}





export const contact_home = [
    {
    id: "contact-1",
    img:"https://www.pngkey.com/png/full/9-96916_download-email-icon-transparent-background.png",
    title: "President Officer Emails",
    content: "Rohit Kulkarni: 922504@lcps.org",
    }
]


export const contact_ml = [
    {
        id: "contact-0",
        img:"https://www.pngkey.com/png/full/9-96916_download-email-icon-transparent-background.png",
        title: "Contact ML Club",
        content: "Club Email: freedom.high.ml@gmail.com",
    },
    {
        id: "contact-1",
        img:"https://www.pngkey.com/png/full/9-96916_download-email-icon-transparent-background.png",
        title: "Contact Rohit Kulkarni - President",
        content: "Rohit Kulkarni: 922504@lcps.org",
    },
    {
        id: "contact-2",
        img:"https://www.pngkey.com/png/full/9-96916_download-email-icon-transparent-background.png",
        title: "Contact Shourya Agarwal - Content Officer",
        content: "Shourya Agarwal: 875644@lcps.org",
    }
]

export const contact_cybersec = [
    {
        id: "contact-1",
        img: "https://www.pngkey.com/png/full/9-96916_download-email-icon-transparent-background.png",
        title: "Cybersecurity Officer Emails",
        content: "Anjana Kumar: 1035151@lcps.org, Shehab Salem: 1044596@lcps.org, Riya Pasupulati: 854076@lcps.org",
    }
]

export const contact_aws = [
    {
        id: "contact-aws",
        img:"https://www.pngkey.com/png/full/9-96916_download-email-icon-transparent-background.png",
        title: "AWS Officer Emails",
        content: "Saamarth Attray: 901395@lcps.org, Suhas Adavelly: 901997@lcps.org",
    }
]